import { useState } from 'react';
import { S } from './styles';

const CATS = ['Starter','Main','Side','Dessert','Drinks','Bread'];

export default function SuggestDishModal({ onClose, onSuggest, prefill }) {
  const [form, setForm] = useState({ name:prefill?.name||'', category:'Starter', method:'pre-prepared', description:prefill?.description||'', recipe:'' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handle() {
    setLoading(true); setError('');
    try { await onSuggest(form); onClose(); }
    catch(e) { setError(e.message); }
    finally { setLoading(false); }
  }

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={e=>e.stopPropagation()}>
        <div style={{display:'flex',justifyContent:'space-between',marginBottom:24}}>
          <div>
            <h3 style={{fontFamily:'Cormorant Garamond,serif',fontSize:24}}>Suggest a dish</h3>
            <p style={{fontSize:13,color:'#7A6555',marginTop:4}}>Tell the host what you'd like to bring</p>
          </div>
          <button onClick={onClose} style={{background:'none',border:'none',fontSize:22,cursor:'pointer',color:'#7A6555'}}>×</button>
        </div>
        {error && <div style={{background:'#FFEBEE',color:'#B71C1C',padding:'10px 14px',borderRadius:8,fontSize:13,marginBottom:16}}>{error}</div>}
        <label style={S.label}>Dish name</label>
        <input style={S.input} placeholder="e.g. Spanakopita" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))}/>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
          <div>
            <label style={S.label}>Category</label>
            <select style={S.input} value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))}>
              {CATS.map(c=><option key={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <label style={S.label}>How</label>
            <select style={S.input} value={form.method} onChange={e=>setForm(f=>({...f,method:e.target.value}))}>
              <option value="pre-prepared">Pre-prepared</option>
              <option value="will make at host's">Make at host's</option>
            </select>
          </div>
        </div>
        <label style={S.label}>Description</label>
        <textarea style={{...S.input,resize:'vertical',minHeight:72}} placeholder="A brief, appetising description…" value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))}/>
        <label style={S.label}>Recipe (optional but encouraged)</label>
        <textarea style={{...S.input,resize:'vertical',minHeight:90}} placeholder="Share the recipe so it lives in party history…" value={form.recipe} onChange={e=>setForm(f=>({...f,recipe:e.target.value}))}/>
        <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
          <button style={S.btnGhost} onClick={onClose}>Cancel</button>
          <button style={{...S.btnPrimary,opacity:(!form.name||loading)?0.5:1}} disabled={!form.name||loading} onClick={handle}>
            {loading ? 'Submitting…' : 'Submit suggestion'}
          </button>
        </div>
      </div>
    </div>
  );
}

const overlay = { position:'fixed',inset:0,background:'rgba(44,26,14,.55)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:300,padding:16 };
const modal   = { background:'white',borderRadius:24,width:'100%',maxWidth:540,maxHeight:'92vh',overflowY:'auto',padding:32 };
